import Router from 'next/router'
import { useEffect, useState } from 'react'
import { SSRGlobal } from '../qecomps/Context'
import Img from '../qecomps/Img'
import { MenuFunc } from './Menu'
import HlsPlayer from '../qecomps/HLSPlayer'
import UserAvatar from '../qecomps/UserAvatar'
import TextBox from '../qecomps/TextBox'
import SerialGenerator from '../qecomps/SerialGenerator'

export default (props) => {
  var [clicked, setClicked] = useState(false)
  var [ping, setPing] = useState(true)
  // useEffect(() => {
  //   setTimeout(() => {
  //     setPing(false)
  //   }, 20000);
  // }, [])

  let z = SSRGlobal()
  return <f-c style={{ flex: 1, position: "relative", width: "100%", overflow: "hidden" }}>

    {props.defaultValue ? <Img src={global.cdn("/files/close.svg")} style={{
      left: z.lang.dir == "rtl" ? 10 : null, right: z.lang.dir == "ltr" ? 10 : null,
      position: "absolute", width: 20, height: 20, opacity: 0.5, cursor: "pointer",
    }} on={() => {
      if (window.location.pathname.includes("/e/") || window.location.pathname.includes("/explore")) {
        Router.push(z.root + "/explore")
      }
      else {
        Router.push(z.root)
      }
    }} /> : null}


    <Img src={z.user.image || "https://cdn.qepal.com/qepal/user.svg"} style={{
      right: z.lang.dir == "rtl" ? 10 : null, left: z.lang.dir == "ltr" ? 10 : null,
      position: "absolute", width: 35, height: 35, opacity: 1, cursor: "pointer", borderRadius: 20
    }} on={async () => {
      await MenuFunc(true)
    }} />

    <div style={{
      cursor: "pointer", position: "absolute", maxWidth: 35, maxHeight: 35,
      left: z.lang.dir == "rtl" ? 10 : null, right: z.lang.dir == "ltr" ? 10 : null,
    }}
      onClick={async () => {
        let result = await modaler((props, refresh, resolve, attributes) => {
          attributes.title = "تلوزیون"
          attributes.maxWidth = window.innerHeight * 0.75 * 16 / 9;
          attributes.style.padding = 0
          attributes.contentStyle = { maxHeight: "95vh" };
          attributes.style.backgroundColor = "black"

          useEffect(() => {
            if (!props.c) {
              props.alivekey = SerialGenerator(5);
              props.n = Math.floor(1 + Math.random() * 225);

              (async () => {
                try {
                  let json = await API["tv/alive"]({ key: props.alivekey })
                  if (json.code == 0) {
                    refresh({ alivecount: json.count, total: json.total, comment: json.comment, videourl: json.videourl })
                  }
                } catch { }
              })()

              props.c = setInterval(async () => {
                try {
                  let json = await API["tv/alive"]({ key: props.alivekey })
                  if (json.code == 0) {
                    refresh({ alivecount: json.count, total: json.total, comment: json.comment, videourl: json.videourl })
                  }
                } catch { }
              }, 5000);
            }
            return () => {
              clearInterval(props.c)
            }
          }, [])
          return <c-cc style={{ backgroundColor: "black" }}>
            <f-csb style={{ width: "100%", marginTop: 3 }}>
              <f-c style={{ position: "relative" }}>
                <span style={{ margin: "0 5px" }} className="absolute inline-flex h-[6px] w-[6px] animate-ping rounded-full bg-red-400 opacity-75"></span>
                <span style={{ margin: "0 5px" }} className="relative inline-flex rounded-full h-[6px] w-[6px] bg-red-500"></span>
                <f-11 style={{ color: "white" }}>پخش آزمایشی</f-11></f-c>
              <f-c style={{ marginTop: 2 }}> <f-11 style={{ color: "white" }}>Turing TV</f-11><sp-2 /></f-c>
            </f-csb>
            <HlsPlayer src={props.videourl || "https://live.qepal.com/armin.m3u8"} />
            <f-csb style={{ width: "100%", marginBottom: 0 }}>
              <f-c style={{ position: "relative" }}>
                <span style={{ margin: "0 5px" }} className="absolute inline-flex h-[6px] w-[6px] animate-ping rounded-full bg-green-400 opacity-75"></span>
                <span style={{ margin: "0 5px" }} className="relative inline-flex rounded-full h-[6px] w-[6px] bg-green-500"></span>
                <f-9 style={{ color: "white" }}>اینترنت نیم بها</f-9></f-c>
              <f-c> <f-9 style={{ color: "white" }}>سرور برج میلاد / ({(props.alivecount || 0).toLocaleString("fa-IR")} بیننده) / ({(props.total || 0).toLocaleString("fa-IR")} بازدید)</f-9><sp-2 /></f-c>
            </f-csb>
            <div style={{ width: "100%", padding: 10 }}>
              {props.comment && <f-c>
                <UserAvatar image={props.comment.avatar || ("https://cdn.qepal.com/qepal/avatar/animal/" + props.comment.n + ".png")} w={20} /> <sp-3 />
                <div style={{ lineHeight: 0.7, paddingBottom: 2 }}>
                  <f-10 style={{ color: "white", lineHeight: 0 }}>{props.comment.comment} </f-10>
                </div>
              </f-c>}
              <br-xx />
              <br-xxx />
              <f-cc style={{ height: 25, backgroundColor: "#212121", width: "100%", borderRadius: 5, padding: "0 10px" }}>
                <textarea onFocus={() => {
                  setTimeout(() => {
                    attributes.style.bottom = 35;
                    attributes.style.top = null;
                    attributes.style.left = "50%"
                    attributes.style.transform = "translate(-50%, 0)"
                    attributes.style.transformOrigin = 0
                    refresh()
                  }, 200);
                }} style={{
                  marginTop: 2, resize: "none", border: "solid black 0px", fontSize: 11
                  , borderRadius: 3, backgroundColor: "#212121", color: "white", width: "100%", height: 20
                }}
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      const text = e.currentTarget.value;
                      e.currentTarget.value = '';
                      await API["tv/comment"]({ n: props.n, comment: text })
                    }
                  }} />
              </f-cc>
            </div>
          </c-cc>
        }, {})
      }}>
      <div className="relative w-[35px] h-[35px]" style={{ maxWidth: 35, maxHeight: 35, }}>
        {ping && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-15"></span>}
        <img src={"https://cdn.qepal.com/qepal/live.png"} style={{
          objectFit: "contain",
          width: 35, height: 35, opacity: 1, cursor: "pointer",
        }} onClick={async () => {
          await MenuFunc(true)
        }} />

      </div>
    </div>

    <input id="search_input" autoComplete="off"
      aria-label='search'
      className={z.styles.textbox}
      style={{
        paddingLeft: 5,
        flex: 1,
        height: 45,
        width: 80,
        padding: "0 55px",
        borderRadius: 50,
        fontFamily: "vr", direction: z.lang.dir as any,
      }}
      placeholder={z.lang.searchexample}
      onClick={(e) => { if (!clicked) { e.target.select(); e.preventDefault(); setClicked(true) } }}
      type='text' defaultValue={props.defaultValue} spellCheck={false}
      onBlur={() => { setClicked(false) }}
      onKeyDown={(event) => {

        var el = event.target
        if (event.key == "Enter" || event.key == "NumpadEnter") {
          if (window.location.pathname.includes("/e/") || window.location.pathname.includes("/explore")) {
            if (!el.value) {
              Router.push(z.root + "/explore")
            }
            else {
              Router.push(z.root + "/e/" + el.value.replace(/ /g, "-"))
            }
          }
          else {
            for (let q of Object.keys(Router.query)) {
              delete Router.query[q];
            }
            var { explore, ...q } = JSON.parse(JSON.stringify(Router.query))
            Router.push({
              pathname: z.root + "/s/" + el.value.replace(/ /g, "-"),
              query: q
            })
          }
        }
      }
      } />
  </f-c>

}